package io.horion.cv.api.datasource.cv

import io.horion.cv.models.PersonalizedSectionType
import kotlinx.serialization.Serializable

@Serializable
data class Section(
    val id: String = "",
    val type: PersonalizedSectionType =
        PersonalizedSectionType.DESCRIPTION,
    val title: String = "",
    val resume: String = "",
    val started: String = "",
    val ended: String = "",
    val description: String = ""
)